import isString from 'lodash/isString';
import { arrayOf, node, number, object } from 'prop-types';
import React from 'react';

import withResolved from '../REST/with-resolved';
import intersperse from '../utils/intersperse';

function join(items, separator) {
  const result = intersperse(items, separator);
  return !separator || isString(separator)
    ? result
    : result.map((element, i) => ({
        ...element,
        key: element.key || `separator-${i}`, // non-string children need to have a key
      }));
}

export default function deriveLinkComponents(LinkComponent, query) {
  const ShowLink = withResolved({
    query,
    deriveQueryArgs: props => ({ id: props.id }),
    as: 'model',
  })(LinkComponent);

  const Link = ({ id, model, ...rest }) => {
    if (model) {
      return <LinkComponent model={model} {...rest} />;
    }
    if (id) {
      return <ShowLink id={id} {...rest} />;
    }

    throw new Error('You need to provide either an id or a model.');
  };

  Link.propTypes = {
    id: number,
    model: object, // eslint-disable-line react/forbid-prop-types
  };

  Link.defaultProps = {
    id: null,
    model: null,
  };

  const Links = ({ ids, models, separator, ...rest }) => {
    if (models) {
      return join(
        models.map((model, idx) => (
          <LinkComponent
            key={`${idx}-${model.id}`} // eslint-disable-line react/no-array-index-key
            model={model}
            {...rest}
          />
        )),
        separator,
      );
    }

    if (ids) {
      return join(
        ids.map(id => <ShowLink key={id} id={id} {...rest} />),
        separator,
      );
    }

    throw new Error('You need to provide either ids or models.');
  };

  Links.propTypes = {
    ids: arrayOf(number),
    models: arrayOf(LinkComponent.propTypes.model),
    separator: node,
  };

  Links.defaultProps = {
    ids: null,
    models: null,
    separator: undefined,
  };

  return { Link, ShowLink, Links }; // export ShowLink only for the tests
}
